export default __webpack_public_path__ + "static/media/PowerGuard.a3f887d0.svg";